import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import cx from "classnames";
import { history } from "../_config/history.config";
import { TextInput } from "../_components/text-input.component";
import { Button } from "../_components/button.component";
import { createSession } from "../_store/_actions/auth.actions";
import { AuthService } from "../_service/auth.service";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import AppImg from "../_assets/vectors/black.svg";

export const RESET_PASSWORD_ROUTE = "/reset-password/:id";

function ResetPasswordPageComponent({ addToast }) {
  const [password, setPassword] = useState(""); // to save password
  const [confirmPassword, setConfirmPassword] = useState(""); // to save password
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [showUserApp, setShowUserApp] = useState(false);
  const [passwordType, setPasswordType] = useState(false);
  const [confPasswordType, setConfPasswordType] = useState(false);
  const isFormSubmitable = password.length > 2 && confirmPassword.length > 2;

  const resetToken = window.location.pathname
    .split("/")
    .filter((d) => d.length > 0)[1];
  const submitForm = (event) => {
    event.preventDefault();
    setIsLoading(true);
    const passwordData = {
      newPassword: password,
      verifyPassword: confirmPassword,
    };
    if (password !== confirmPassword) {
      setIsLoading(false);
      addToast("Password does not match.", "", ToastTypes.danger);
      return;
    }
    AuthService.resetPassword(passwordData, resetToken)
      .then((resp) => {
        setIsLoading(false);
        setShowUserApp(true);
        addToast("Password changed successfully.", "", ToastTypes.success);
        // history.push("/");
      })
      .catch((error) => {
        setIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };
  return (
    <div className="ResetPasswordPage reset-password-page">
      <div className="flex justify-center items-center reset-container-h">
        {!showUserApp ? (
          <div className="relative">
            <div className="">
              <p className="font-bold mb-11 text-3xl text-center text-primary">
                Vitalize Create Password
              </p>
            </div>
            <div className="absolute w-full bottom-40">
              {error ? (
                <div className="bg-red-500 rounded px-2 py-4">
                  <p className="text-white">{error}</p>
                </div>
              ) : (
                <></>
              )}
            </div>
            <form onSubmit={submitForm}>
              <div>
                <TextInput
                  type={!passwordType ? "password" : "text"}
                  placeholder="New Password"
                  containerClassName="flex-grow block"
                  className="py-4"
                  inputHolderClassName="rounded-xl"
                  onChange={(value) => {
                    setPassword(value);
                  }}
                  postfix={
                    <div
                      onClick={() => setPasswordType(!passwordType)}
                      className="text-xxs text-primary mr-3 cursor-pointer">
                      {!passwordType ? "View" : "Hide"}
                    </div>
                  }
                />
                <TextInput
                  type={!confPasswordType ? "password" : "text"}
                  placeholder="Re-enter Your New Password"
                  containerClassName="flex-grow block"
                  inputHolderClassName="rounded-xl"
                  className="py-4"
                  onChange={(value) => {
                    setConfirmPassword(value);
                  }}
                  postfix={
                    <div
                      onClick={() => setConfPasswordType(!confPasswordType)}
                      className="text-xxs text-primary mr-3 cursor-pointer">
                      {!confPasswordType ? "View" : "Hide"}
                    </div>
                  }
                />
                <div className="flex justify-center">
                  <Button
                    disabled={!isFormSubmitable}
                    className="mt-2 px-5 py-3.5 w-1/2 text-lg rounded-2xl"
                    isLoading={isLoading}
                    label="Submit"
                    type="submit"
                  />
                </div>
              </div>
            </form>
          </div>
        ) : (
          <></>
        )}
        {showUserApp ? (
          <div className="relative bg-white">
            <div className="m-auto mb-4 mt-11 w-2/3">
              <p className="font-bold text-xl text-center text-primary">
                Your Password has been changed successfully!
              </p>
            </div>
            <div className="m-auto mb-11 w-1/2">
              <a href="https://apple.co/3z6gaQA" target="_blank">
                <img src={AppImg} />
              </a>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

const ResetPasswordPage = withToast(ResetPasswordPageComponent);
// const LoginPage = connect(mapStateToProps, mapDispatchToProps)(LoginPageComponent);

export default ResetPasswordPage;
